import { reportType } from '../../../infrastructure/constants/reportType';
import ReportConfig from '../../../types/report/ReportConfig';
import stringHelper from '../../../infrastructure/helpers/common/stringHelper';
import typeHelper from '../../../infrastructure/helpers/common/typeHelper';
import validateConfigName from '../../../infrastructure/helpers/common/validator/nameValidator';
import GlobalModuleConfig from '../../../types/report/GlobalModuleConfig';

const validateDataSources = (reportConfig: ReportConfig): string | null => {

    let error = validateConfigName(reportConfig.name, true);
    if (error) {
        return error;
    }

    if (reportConfig.type !== reportType.globalModule && stringHelper.isEmpty(reportConfig.regime)) {
        return 'Reporting regime is required';
    }

    if (reportConfig.type === reportType.accuracy) {

        return null;
    }

    if (reportConfig.type !== reportType.globalModule && (!typeHelper.isNumber(reportConfig.rawDataSourceId))) {
        return 'Raw data source is required';

    }

    //if (reportConfig.refDataSources.some(x => x.id === reportConfig.rawDataSourceId)) {
    //    return 'Raw data source must be different than ref data sources';
    //}

    return null;
};

const validateGlobalModuleConfigDataSources = (globalModuleConfig: ReportConfig): string | null => {

    let error = validateConfigName(globalModuleConfig.name, true);
    if (error) {
        return error;
    }

    return null;
};

const dataSourceValidators = { validateDataSources, validateGlobalModuleConfigDataSources }

export default dataSourceValidators;
